// View for the table of entries in the database - gives a brief overview of each entry (more detail shown than in the card view)

import AutoSVG from "../visualizer-tool/automatic-svg/AutoSVG"
import '../css/tableview.css'
import InfoCardModal from "./InfoCardModal";
// helper function from databaseUtils
import databaseUtils from '../databaseUtils';

export default function TableView({ data, handleEntryClick, selectedEntry, modalOpen, handleModalClose}) {
    
    // Prevents the click from bubbling up to the parent for the DOI link
    const stopPropagation = (event) => {
        event.stopPropagation(); // Prevents the click from bubbling up to the parent <tr>
    };

    function formatSpecies(species) {
        if (!species) return "";

        const words = species.trim().split(" ");
        if (words.length < 2) return species;

        const firstInitial = words[0][0].toUpperCase();
        const secondWord = words.slice(1).join(" ");

        return `${firstInitial}. ${secondWord}`;
    }   

    return (
        <div style={{overflowY:"auto", flex:'1 1 auto'}}>
            <div style={{overflowX: "auto", width: "100%"}}>
                <table className="ui celled collapsing compact table" style={{borderRadius:"2vh" }}>
                    <thead style={{position:"sticky", top:"0",zIndex:"1"}}>
                        <tr>
                            <th className="collapsing" ><h3>Serotype</h3></th>
                            <th ><h3>SNFG</h3></th>
                            <th><h3>Chemical Structure</h3></th>
                            <th><h4>Ru Length</h4></th>
                            <th><h4>DOI</h4></th>
                        </tr>
                    </thead>
                    <tbody style={{overflowY:"auto"}}>
                        {data.map((entry, index) => (
                            <tr className="table-row" key={index} onClick={() => handleEntryClick(entry)}>
                              
                                <td  className="Serotype"><div class="ui label" style={{backgroundColor:databaseUtils.colourMap(entry.Species_where_found)}}><h3>{entry.Serotype}</h3></div></td>
                                <td className="SNFG"> <AutoSVG casperString={entry.Antigen_structure === "" ? entry.Carbuilder_structure_format : entry.Antigen_structure}/> </td>
                                <td style={{cursor: 'text'}} >
                                    <span onClick={stopPropagation}>{entry.Antigen_structure}</span>
                                </td>
                                <td>{entry.Repeat_unit_size === 0 ? "" : entry.Repeat_unit_size}</td>
                                <td onClick={stopPropagation} className="doi-box">
                                    <a className='doi' href={entry.DOI} target="_blank" rel="noopener noreferrer" >
                                        {entry.DOI}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {selectedEntry && (
                <InfoCardModal
                    entry={selectedEntry}
                    open={modalOpen}
                    onClose={handleModalClose}
                />
            )}
        </div>
    )
}
